import Layout from '@/views/layout/index'
import permCode from '@/config/permCode'

export default [
  {
    path: '/hrm',
    component: Layout,
    hidden: true,
    meta: {},
    children: [{
      path: '/roster/index',
      meta: {
        permission: permCode.ROSTER_LIST,
      },
      component: () => import('@/views/hrm/roster/index'),
    }]
  }
]
